import { ReactNode } from 'react';

import classNames from 'classnames';

import { ExternalLink } from '@uikit';

import { ProjectContentTableOfContentTab } from '../types';
import { ItemsProps } from '../types';
import { guaranteedRewards, publicPool, sqrpPool, whitelistPool } from './constants';

export type SubTitleProps = {
  children: ReactNode;
  className?: string;
};

export type ListProps = {
  items: Array<ItemsProps>;
  description: string;
  className?: string;
};

const SubTitle = ({ children, className }: SubTitleProps) => {
  return (
    <h3 className={classNames('text-2xl font-semibold text-neutral-500 ', className)}>
      {children}
    </h3>
  );
};

const List = ({ items, description, className }: ListProps) => {
  return (
    <>
      <p className="mb-4 text-lg font-semibold text-neutral-600">{description}</p>
      <ul className={classNames('list-disc pl-6', className)}>
        {items.map(({ id, content, item }) => {
          if (Array.isArray(item)) {
            return (
              <li key={id} className="font-normal">
                {content}
                <ul className="list-disc pl-6">
                  {item.map(({ id: subId, subItem }) => (
                    <li key={subId}>{subItem}</li>
                  ))}
                </ul>
              </li>
            );
          } else {
            return <li key={id}>{item}</li>;
          }
        })}
      </ul>
    </>
  );
};

export const tableOfContentTab: ProjectContentTableOfContentTab['content'] = [
  {
    id: 'intro',
    title: 'Introduction and Highlights',
    content: (
      <>
        <SubTitle className="mb-4">🚀 Experience the Future of Web3:</SubTitle>
        <p className="mb-6">
          Join us at Magic Launchpad for our inaugural TEST IDO, a crucial step toward optimizing
          our new decentralized platform. Your participation is essential in helping us identify
          bugs, ensure effective load balancing, and enhance overall performance.
        </p>
        <SubTitle className="mb-4">🌐 How to Participate:</SubTitle>
        <p>
          Simply visit{' '}
          <ExternalLink
            href="https://launchpad.magicsquare.io"
            className="text-base font-medium text-primary-700 underline"
          >
            launchpad.magicsquare.io
          </ExternalLink>{' '}
          and engage in our first-ever token sale. This isn't just a test; it's your opportunity to
          be part of something bigger and help us refine our innovative product.
        </p>
      </>
    ),
  },
  {
    id: 'token-sales-with-benefits',
    title: 'Exclusive Token Sale with Benefits',
    content: (
      <>
        <p className="mb-6">
          Dive into a launchpad-style sale and secure SQR Tokens at a 10% discount. If the SQR Token
          is priced at $0.40, you'll get it for just $0.36. Explore three distinct pools tailored to
          diverse participant interests:
        </p>
        <SubTitle className="mb-4">💰Detailed Pool Descriptions</SubTitle>
        <List items={publicPool} className="mb-4" description="FCFS Public Pool:" />
        <List items={whitelistPool} className="mb-4" description="Whitelist Pool:" />
        <List items={sqrpPool} description="SQRp Pool:" />
      </>
    ),
  },
  {
    id: 'guaranteed-rewards',
    title: 'Guaranteed Rewards',
    content: (
      <>
        <p className="mb-4">
          All campaign participants will receive guaranteed rewards including KARMA points, SQR
          Tokens, and discounted SQR from their allocations—up to $15 USDT per user.
        </p>
        <SubTitle className="mb-4">Guidelines for Participation</SubTitle>
        <List items={guaranteedRewards} className="mb-4" description="SQRp Pool:" />
        <p className="text-lg font-semibold text-secondary-700">
          🌟 Don’t miss this unique opportunity to shape the future of Web3 technologies and secure
          exclusive benefits. Your active participation is key to a seamless and robust Magic
          Launchpad.
        </p>
      </>
    ),
  },
];
